

import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAuth } from "../context/AuthContext";
import { selectIsLoggedIn, selectUser } from "../redux/features/auth/AuthSlice";

const ProtectedRoute = ({children}) => {
  const user = useSelector(selectUser);
  const isAuthenticated = useSelector(selectIsLoggedIn);
  const { loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
